import { getCurrentEnvironment } from '@telstra-connect/config/config';
import {flagIsSet} from '@telstra-connect/feature-flags';
import { IFeatureFlags, IUserProfileFeatureFlags } from './common';
import { IFeatureFlags as IFeaturePMFlags } from './common-planned-maintenance';
import flagsData from './flags';
import global from '../../../applications/global';

let featureFlags: IFeatureFlags;

export const loadFeatureFlags = (): void => {
    const environment = getCurrentEnvironment();
    // the step to check for flags is implemented statically to have typescript/intellisense support
    featureFlags = Object.freeze({
        // example usage:
        CCDIntEnquiry: flagIsSet(flagsData.CCDIntEnquiry, environment),
        CCDFileAttachment: flagIsSet(flagsData.CCDFileAttachment, environment),
        application: flagIsSet(flagsData.application, environment),
        customerSupportRebuildPhaseTwo: flagIsSet(flagsData.customerSupportRebuildPhaseTwo, environment),
        SupportEnquiriesIntUnifiedTrack: flagIsSet(flagsData.SupportEnquiriesIntUnifiedTrack, environment),
        CCDIntSupportUnifiedList: flagIsSet(flagsData.CCDIntSupportUnifiedList, environment),
        ShowNpsFeedbackFromPlatformGlobalExpose: flagsData.ShowNpsFeedbackFromPlatformGlobalExpose[environment],
        tedig3350AccessibilityUpliftedCaseDetailsPage: flagIsSet(flagsData.tedig3350AccessibilityUpliftedCaseDetailsPage, environment),
        tedig3349BanAndSearchAndListPageUplift: flagIsSet(flagsData.tedig3349BanAndSearchAndListPageUplift, environment),
    });
};

export const getChannelCareFlags = (): IFeatureFlags => {
    return global.applications['Channel Care'];
};

export const getUserProfileFlags = (): IUserProfileFeatureFlags => {
    return global.applications.Platform;
};

export const getPlannedMaintenanceFlags = (): IFeaturePMFlags => {
    return global.applications['Planned Maintenance'];
};
